<template>
  <div>
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>

    <nav-section></nav-section>

    <copyright-section></copyright-section>
  </div>
</template>

<script>
import NavSection from './NavSection'
import CopyrightSection from './CopyrightSection'

export default {
  name: 'ContactPage',
  methods: {

  },
  components: {
    NavSection,
    CopyrightSection
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ContactPage.vue